import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { ModulosEnumChoice, newMotivoRechazoSchema } from '@/shared';
import { useCreateMotivoRechazo, useUpdateMotivoRechazo } from '@/shared/actions/erp';
import {
  CustomAutocomplete,
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { MotivoRechazo } from '@/shared/interfaces';
import CustomAutocompleteMultipleArrString from '@/shared/components/ui/CustomAutocompleteMultipleArrString';


const returnUrlMR = '/parametrizacion/motivo-rechazo';

export interface SaveMotivoRechazoInterface {
  titlePage: string;
  editMotivoRechazo?: MotivoRechazo;
}

type SaveFormData = {
  nombre: string;
  codigo: string;
  modulo: string;
  estado: boolean;
  destinos?: string[];
};
/* export type ModuloOption = {
  destinos: string[]
} */

const SaveMotivoRechazo: React.FC<SaveMotivoRechazoInterface> = ({ titlePage, editMotivoRechazo, }) => {

  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);
  const [dataModulo, setDataModulo] = useState<string[]>([])

  ///* mutations
  const createMotivoRechazoMutation = useCreateMotivoRechazo({ navigate, returnUrl: returnUrlMR });
  const updateMotivoRechazoMutation = useUpdateMotivoRechazo({ navigate, returnUrl: returnUrlMR });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newMotivoRechazoSchema),
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    /* console.log('json', form.getValues())
    return */
    if (!isValid) return;

    ///* upd
    if (editMotivoRechazo?.id_motivo_rechazo) {
      return updateMotivoRechazoMutation.mutate({
        id: editMotivoRechazo.id_motivo_rechazo,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createMotivoRechazoMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editMotivoRechazo) {
      setShrink(true);
      reset({
        ...editMotivoRechazo,
        destinos: editMotivoRechazo.destinos
      } as any);
    }
  }, [editMotivoRechazo]);

  const modulosOptions = Object.entries(ModulosEnumChoice).map(
    ([key, value]) => ({ label: key, value })
  );

  useEffect(() => {
    const options = Object.values(ModulosEnumChoice);
    setDataModulo(options as string[]);
  }, [])

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlMR);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Codigo"
        name="codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />
      <CustomTextField
        label="nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />
      <CustomAutocomplete
        label="Modulo"
        name="modulo"
        control={form.control}
        defaultValue={form.getValues().modulo || ''}
        error={errors.modulo}
        helperText={errors.modulo?.message}
        options={modulosOptions}
        isLoadingData={false}
        valueKey="value"
        optionLabelForEdit={form.getValues().modulo}
      />
      <CustomAutocompleteMultipleArrString
        label='Destino'
        name='destinos'
        control={form.control}
        options={dataModulo}
        isLoadingData={false}
        defaultValue={editMotivoRechazo?.destinos as string[]  ?? []}
        error={!!errors.destinos}
        helperText={false}
        textFieldKey={'destinos'}
        enableStringify={false}
      />


      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado || false}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveMotivoRechazo;
